import React, { useState, useEffect } from 'react';
import { getUserOrgs } from '../../services/firestoreService';

const OrgSelector = ({ user, orgIds, onSelectOrg }) => {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrgs = async () => {
      try {
        const orgList = await getUserOrgs(orgIds);
        setOrgs(orgList);
      } catch (err) {
        console.error('Error loading organizations:', err);
      }
      setLoading(false);
    };
    fetchOrgs();
  }, [orgIds]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen" style={{ backgroundColor: '#071D39' }}>
        <p style={{ color: '#FFFFFF', fontFamily: 'AvenirNext', fontSize: '18px' }}>Loading your accounts...</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen" style={{ backgroundColor: '#071D39' }}>
      <div style={{ width: '100%', maxWidth: '480px', padding: '0 24px' }}>
        {/* Logo */}
        <div className="flex justify-center" style={{ marginBottom: '32px' }}>
          <img
            src="/closd-logo-dark-bg.png"
            alt="CLOSd"
            style={{ height: '48px' }}
          />
        </div>

        {/* Welcome message */}
        <h1 style={{
          fontFamily: 'AvenirNext',
          fontWeight: 600,
          fontSize: '24px',
          color: '#FFFFFF',
          textAlign: 'center',
          marginBottom: '8px',
        }}>
          Welcome back, {user.firstName || 'there'}!
        </h1>
        <p style={{
          fontFamily: 'AvenirNext',
          fontSize: '16px',
          color: '#89A8B1',
          textAlign: 'center',
          marginBottom: '32px',
        }}>
          Which account would you like to open?
        </p>

        {/* Org list */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {orgs.map((org) => (
            <button
              key={org.id}
              onClick={() => onSelectOrg(org.id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                padding: '16px 20px',
                backgroundColor: '#0F2A4A',
                border: '1px solid #1E3A5F',
                borderRadius: '10px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                textAlign: 'left',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#163455';
                e.currentTarget.style.borderColor = '#75BB2E';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#0F2A4A';
                e.currentTarget.style.borderColor = '#1E3A5F';
              }}
            >
              <div>
                <div style={{
                  fontFamily: 'AvenirNext',
                  fontWeight: 600,
                  fontSize: '17px',
                  color: '#FFFFFF',
                  marginBottom: '4px',
                }}>
                  {org.name || 'Unnamed Organization'}
                </div>
                <div style={{
                  fontFamily: 'AvenirNext',
                  fontSize: '13px',
                  color: '#89A8B1',
                }}>
                  {org.plan === 'trial' ? 'Trial' : org.plan === 'founding' ? 'Founding 100' : org.plan === 'cancelled' ? 'Cancelled' : 'Active'} account
                </div>
              </div>
              <div style={{
                fontFamily: 'AvenirNext',
                fontSize: '22px',
                color: '#516469',
              }}>
                →
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OrgSelector;